const {jQuery: $} = window;
import Utils from "./utils.class";
import InPageNav from "./inPageNav.class";
import TabsLayout from "./layouts/tabs";
import PeopleGrid from "./layouts/people_grid";
import Timeline from "./layouts/timeline";
import Stat from "./components/stat";
import RotatingTabs from "./layouts/rotating_tabs";
import Featherlight from "./../lib/featherlight";
import Accordion from "./accordion.class";

import Cookies from 'js-cookie';

export default class Theme {
    $main;
    $html;
    $body;
    $header;
    #builder;
    #inPageNav;
    #config;
    #scrollOffset;
    scrollSpeed;
    #TabsLayout;
    #RotatingTabs;
    #PeopleGrid;
    #Timeline;
    #Stat;
    #utils;
    #slider;
    #root;

    #AccordionModule
    #counter;

    constructor(
        config,
        builder,
        utils,
        slider
    ) {
        this.#config = config;
        this.#builder = builder;
        this.#utils = utils;
        this.#root = document.querySelector(":root");

        this.#scrollOffset = 50;
        this.scrollSpeed = 750;

        this.$html = $('html');
        this.$body = $('body');
        this.$main = $('.site-wrapper');
        this.$header = $('header.site_header');
        this.#inPageNav = new InPageNav(this);
        this.#TabsLayout = new TabsLayout(this);
        this.#RotatingTabs = new RotatingTabs(this);
        this.#PeopleGrid = new PeopleGrid(this);
        this.#Timeline = new Timeline(this);
        this.#Stat = new Stat();
        this.#AccordionModule = new Accordion(this);

        this.#counter = $('.counter__number');
        this.#slider = slider

        if (window.location.hash === "#dev") {
            Cookies.set("debug", 1);
        }

    }

    __onReady() {
        const me = this;

        Utils.log("Theme Ready");

        me.#TabsLayout.events();
        me.#PeopleGrid.events();
        me.#Timeline.events();
        me.#Stat.events();
        me.#slider.setup();

        this.#updateCssHeaderHeight();

        $(window).on('hashchange', function (e) {
            Utils.log("Scroll to Section Ready");

            if (location.hash) {
                if (Utils.scrollToHash(location.hash, null, me.scrollOffset, me.scrollSpeed)) {
                    e.preventDefault();
                }
            }
        });


        $('a').on('click', function (e) {
            let $el = $(this);

            if ($el.attr('href').search('#') !== -1) {
                let hash = $el[0].hash;

                if (Utils.scrollToHash(hash, null, me.scrollOffset, me.scrollSpeed)) {
                    e.preventDefault();
                }
            }
        });

        $('a').each(function (i, el) {
            var url = $(el).attr("href");
            // use url.indexOf() to look for youtube embed urls
            // apply featherlight on those tags
            if (url) {
                if (url.indexOf("youtube.com/watch?v=") >= 0 || url.indexOf("youtu.be/") >= 0 || url.indexOf("youtube.com/embed/") >= 0
                    || url.indexOf("youtube-nocookie.com/watch?v=") >= 0 || (url.indexOf("youtube-nocookie.com/embed/") >= 0)) {
                    var id = Utils.youtubeParser(url);
                    $(el).attr("data-featherlight", "iframe")
                        .attr("data-featherlight-iframe-width", "850")
                        .attr("data-featherlight-iframe-height", "468")
                        .attr("data-featherlight-iframe-frameborder", "0")
                        .attr("data-featherlight-iframe-allow", "autoplay; encrypted-media")
                        .attr("data-featherlight-iframe-allowfullscreen", "true")
                        .attr("href", "https://www.youtube-nocookie.com/embed/" + id + "?rel=0&autoplay=1");

                    $(el).featherlight();
                }   else if (Utils.getVimeoId(url)) {
                    var id = Utils.getVimeoId(url);
                    $(el).attr("data-featherlight", "iframe")
                        .attr("data-featherlight-iframe-width", "850")
                        .attr("data-featherlight-iframe-height", "468")
                        .attr("data-featherlight-iframe-frameborder", "0")
                        .attr("data-featherlight-iframe-allow", "autoplay; encrypted-media")
                        .attr("data-featherlight-iframe-allowfullscreen", "true")
                        .attr("href", "https://player.vimeo.com/video/" + id + "?rel=0&autoplay=1");

                    $(el).featherlight();
                }
            }
        });

        $("#menu-wrapper").mmenu(
            {
                "navbar": {
                    "title": mmtitle,
                },
                "navbars": [
                    {
                        "position": "bottom",
                        "content": [
                            "searchfield"
                        ]
                    }
                ],
                "extensions": [
                    "pagedim-black",
                    "theme-dark",
                    "position-right"
                ],
                "searchfield": {
                    "search": false,
                },
                classNames: {
                    fixedElements: {
                        fixed: "fix",
                        sticky: "stick"
                    }
                }
            }, {
                "searchfield": {
                    "form": {
                        "method": 'GET',
                        "action": homeurl
                    },
                    "input": {
                        "name": 's'
                    }
                }
            }
        );

        me.#AccordionModule.run();
    }

    __onLoad() {
        const me = this;

        Utils.log("Theme Load");
        me.#slider.show();

        Utils.equalHeight('.image_callout__text', '.builder-layout');
        Utils.equalHeight('.graphic_card__text', '.builder-layout');
        Utils.equalHeight('.rollover-height', '.builder-section-type--rollover');
        Utils.equalHeight('.content-title', '.slick-track');

        //this.$header.addClass('fixed');
        $(window).trigger("resize");

        if (location.hash) {
            Utils.log("Scroll to Section Load");

            setTimeout(function () {
                Utils.scrollToHash(location.hash, null, me.scrollOffset, me.scrollSpeed);

            }, 300);
        }

        setTimeout(function () {
            me.#inPageNav.events();
            $(window).trigger("resize");
        }, 1000);

        Utils.equalHeight('.js-equalizer-logo', '.logo-slider-container');
        Utils.equalHeight('.tabbed_section__js', '.tabbed_section');

        function counter(el) {
            let $me = $(el),
                time = ($me.attr('data-time') || 3000) * 1000,
                countTo = $me.attr('data-count'),
                delay = ($me.attr('data-delay') || 0) * 1000;

            setTimeout(function () {
                $({
                    countNum: 0
                }).animate({
                        countNum: countTo
                    },

                    {
                        duration: 3000,
                        easing: 'linear',
                        step: function () {
                            $me.text(Utils.commaSeparateNumber(Math.floor(this.countNum)));
                        },
                        complete: function () {
                            $me.text(Utils.commaSeparateNumber(this.countNum));
                        }
                    }
                );
            }, delay);
        }

        this.#counter.each(function (i, el) {

            $(el).on('animationTrigger', function () {
                counter(el);
            });

            $(el).data('waypoint', new Waypoint.Inview({
                element: el,
                entered: function (dir) {
                    if ($(el).parents('.animation-trigger').length == 0) {
                        counter(el);
                    }
                },
                exited: function (dir) {

                }
            }));
        });

        $('.search-bar .search-button').on('click', function () {
            $(this).parent().toggleClass('open');
        });

        // Mobile Menu Toggle
        $('.site_header .site_header__menu_toggle').on('click', function () {
            $(this).parent().toggleClass('mobile-open');
        });

        // Mobile Menu Inner Items Close On Click
        $('.menu-item-object-custom a').on('click', function () {
            if ($(this).attr('href') !== '#') {
                $(this).closest('.site_header').removeClass('mobile-open');
            }
        });

        // Mobile Menu Inner Items
        $('.menu-item-has-children a').on('click', function () {
            let $list = $(this).parent();

            $list.toggleClass('mobile-list-open');
            $list.find('.sub-menu').slideToggle({
                duration: 350,
                progress: function () {
                    $(window).trigger('resize');
                }
            });
        });

        $('.single_accordion .single_accordion__header').on('click keydown', function (e) {
            if (e.type === 'keydown') {
                if (e.key !== 'Enter' && e.key !== ' ') {
                    return;
                }

                e.preventDefault();
            }

            let $column = $(this).parent();
            const behavior = $column.closest('.accordions').data('open-behavior') || 'independent';

            // "One at a time" behaviors close any open sibling before opening this one
            if (behavior !== 'independent' && !$column.hasClass('open')) {
                $column.siblings('.single_accordion.open').each(function () {
                    $(this).removeClass('open');
                    $(this).find('.single_accordion__header').attr('aria-expanded', 'false');
                    $(this).find('.single_accordion__inner').slideUp(250);
                });
            }

            $column.toggleClass('open');
            $(this).attr('aria-expanded', $column.hasClass('open') ? 'true' : 'false');
            $column.find('.single_accordion__inner').slideToggle({
                duration: 250,
                progress: function () {
                    $(window).trigger('resize');
                }
            });
        });

        $(".locGallery__gallery .kpfsc__posts").featherlightGallery({filter: ".locGallery__item"});

        this.#updateCssHeaderHeight();
    }

    __onResize() {
        this.#updateCssHeaderHeight();
    }

    /**
     * @param {PostFilters} kpf
     * @private
     */
    __postFilters(kpf) {
        Utils.log("Theme customizations for Post Filters...");

        kpf.addAction('posts_transition_finished', function (response, settings) {

            $('a').each(function (i,  el) {
                var url = $(el).attr("href");
                // use url.indexOf() to look for youtube embed urls
                // apply featherlight on those tags
                if (url) {
                    if (url.indexOf("youtube.com/watch?v=") >= 0 || url.indexOf("youtu.be/") >= 0 || url.indexOf("youtube.com/embed/") >= 0
                        || url.indexOf("youtube-nocookie.com/watch?v=") >= 0 || (url.indexOf("youtube-nocookie.com/embed/") >= 0)) {
                        var id = Utils.youtubeParser(url);
                        $(el).attr("data-featherlight", "iframe")
                            .attr("data-featherlight-iframe-width", "850")
                            .attr("data-featherlight-iframe-height", "468")
                            .attr("data-featherlight-iframe-frameborder", "0")
                            .attr("data-featherlight-iframe-allow", "autoplay; encrypted-media")
                            .attr("data-featherlight-iframe-allowfullscreen", "true")
                            .attr("href", "https://www.youtube-nocookie.com/embed/" + id + "?rel=0&autoplay=1");

                        $(el).featherlight();
                    }  else if (Utils.getVimeoId(url)) {
                        var id = Utils.getVimeoId(url);
                        $(el).attr("data-featherlight", "iframe")
                            .attr("data-featherlight-iframe-width", "850")
                            .attr("data-featherlight-iframe-height", "468")
                            .attr("data-featherlight-iframe-frameborder", "0")
                            .attr("data-featherlight-iframe-allow", "autoplay; encrypted-media")
                            .attr("data-featherlight-iframe-allowfullscreen", "true")
                            .attr("href", "https://player.vimeo.com/video/" + id + "?rel=0&autoplay=1");

                        $(el).featherlight();
                    }
                }
            })
        })

        // Newsroom pill filters (post-filters/templates/filters/tax-newsroom.php): the plugin only
        // refreshes posts when its select changes, so each pill sets the hidden select's value.
        $(document).on('click', '.kpfsc__filter--pills .kpfsc__pill', function () {
            const $select = $(this).closest('.kpfsc__filter').find('select');
            const value = String($(this).data('value'));

            if (String($select.val() || '') !== value) {
                $select.val(value).trigger('change');
            }
        });

        // Keep the pills in sync with the select, including Clear and back/forward restores
        $(document).on('change', '.kpfsc__filter--pills select', function () {
            const value = String($(this).val() || '');

            $(this).closest('.kpfsc__filter').find('.kpfsc__pill').each(function () {
                const isActive = String($(this).data('value')) === value;

                $(this).toggleClass('is-active', isActive).attr('aria-pressed', isActive ? 'true' : 'false');
            });
        });
    }


    activatePlayer() {
        // TODO: Implement video platform integration
    }

    get utils() {
        return Utils;
    }

    get headerHeight() {
        return this.$header.outerHeight();
    }

    get scrollOffset() {
        let subNav = 0;

        if (this.#inPageNav.isActive) {
            subNav = this.#inPageNav.height;
        }

        return this.#scrollOffset + this.headerHeight + subNav;
    }

    #updateCssHeaderHeight() {
        this.#root.style.setProperty('--header-height', this.headerHeight + "px");
    }
}